import api from "../api";

/*lookupService*/
// Ambil semua user untuk dropdown / mapping
export const getUserOptions = async () => {
  try {
    const res = await api.get("/Lookup/Userpj"); // endpoint user master
    const items = Array.isArray(res.data) ? res.data : [];
    return items.map((item) => ({
      value: item.idUser,
      label: item.namaLengkap,
    }));
  } catch (error) {
    console.error("Gagal memuat data User:", error);
    return [];
  }
};
export const getRekeningSediaOptions = async () => {
  const res = await api.get("/Lookup/Rekening");
  return res.data;
};

/*Kebutuhan lookup detail*/
export const getRekeningNonPersediaanOptions = async () => {
  try {
    const res = await api.get("/Lookup/RekeningNon");
    const data = Array.isArray(res.data) ? res.data : [];
    return data.map((item) => ({
      value: item.idRekening,
      label: `${item.kodeRekening}-${item.namaRekening}`,
      idSatuan: item.idSatuan,
      kodeRekening: item.kodeRekening,
      namaRekening: item.namaRekening,
      idCatat: item.idCatat,
    }));
  } catch (error) {
    // console.error("Gagal memuat data Rekening Non Persediaan:", error);
    throw new Error("Gagal memuat data Rekening Non Persediaan");
  }
};
export const getRekeningOptions = async () => {
  try {
    const res = await api.get("/Lookup/Rekening");
    const data = Array.isArray(res.data) ? res.data : [];
    return data.map((item) => ({
      value: item.idRekening,
      // label: item.namaRekening,
      label: `${item.kodeRekening}-${item.namaRekening}`,
      idSatuan: item.idSatuan,
      kodeRekening: item.kodeRekening,
      namaRekening: item.namaRekening,
    }));
  } catch (error) {
    console.error("Gagal memuat data Jenis Rekening:", error);
    throw new Error("Gagal memuat data Jenis Rekening");
  }
};

export const getPersediaanDetailOptions = async () => {
  try {
    const res = await api.get("/Lookup/Persediaandet"); // sesuaikan endpointnya
    // Misal response.data adalah array barang dengan properti id dan nama
    return res.data.map((item) => ({
      value: item.idKodePersediaan || item.id, // sesuaikan properti id sesuai respons API-mu
      label: item.namaPersediaan,
    }));
  } catch (error) {
    console.error("Gagal mengambil data Persediaan:", error);
    return [];
  }
};

export const getBarangDetailOptions = async () => {
  try {
    const res = await api.get("/Lookup/Barangdet"); // sesuaikan endpointnya
    // Misal response.data adalah array barang dengan properti id dan nama
    return res.data.map((item) => ({
      value: item.idBarang || item.id, // sesuaikan properti id sesuai respons API-mu
      label: item.namaBarang || item.nmbarang || item.nama || item.nmBarang,
    }));
  } catch (error) {
    console.error("Gagal mengambil data barang:", error);
    return [];
  }
};
export const getSatuanDetailOptions = async () => {
  try {
    const res = await api.get("/Lookup/Satuan"); // sesuaikan endpointnya
    // Misal response.data adalah array satuan dengan properti id dan nama
    return res.data.map((item) => ({
      value: item.idSatuan || item.id, // sesuaikan properti id sesuai respons API-mu
      label: item.namaSatuan,
    }));
  } catch (error) {
    console.error("Gagal mengambil data Satuan:", error);
    return [];
  }
};

// utilitas umum: group array berdasarkan key, lalu map ke format options
export const groupByIdAndMap = (data, idKey, mapFn) => {
  if (!Array.isArray(data)) return {};
  return data.reduce((acc, item) => {
    const key = item[idKey];
    if (!acc[key]) acc[key] = [];
    acc[key].push(mapFn(item));
    return acc;
  }, {});
};

export const getPersediaanOptions = async () => {
  const res = await api.get("/Lookup/Persediaandet");
  return res.data;
};

export const getPersediaanByIdOptions = async (idRekening) => {
  try {
    const res = await api.get(`/Lookup/Persediaan?IdRekening=${idRekening}`);
    const data = Array.isArray(res.data) ? res.data : [];
    return data.map((item) => ({
      value: item.idKodePersediaan,
      // label: item.namaPersediaan,
      label: `${item.kodePersediaan}-${item.namaPersediaan}`,

      kodePersediaan: item.kodePersediaan,
    }));
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return [];
    }
    console.error("Gagal memuat data Persediaan:", error);
    throw new Error("Gagal memuat data Persediaan");
  }
};

export const getAllPersediaan = async () => {
  try {
    const res = await api.get(`/Lookup/Persediaan`);
    const data = Array.isArray(res.data) ? res.data : [];
    return groupByIdAndMap(data, "idRekening", (item) => ({
      value: item.idKodePersediaan,
      label: item.namaPersediaan,
      kodePersediaan: item.kodePersediaan,
    }));
  } catch (error) {
    console.error("Gagal memuat semua data Persediaan:", error);
    return {};
  }
};

export const getAllRekening = getRekeningOptions;

export const getBarangOptions = async (idKodePersediaan) => {
  if (!idKodePersediaan) return [];
  try {
    const res = await api.get(
      `/Lookup/Barang?IdKodePersediaan=${idKodePersediaan}`,
    );
    const data = Array.isArray(res.data) ? res.data : [];
    return data.map((item) => ({
      value: item.idBarang,
      // label: item.namaBarang,
      kodeBarang: item.kodeBarang,
      label: `${item.namaBarang}-${item.namaSatuan}`,
      idSatuan: item.idSatuan,
      namaSatuan: item.namaSatuan,
      // hargaBeli: item.hargaBeli,
    }));
  } catch (error) {
    console.error("Gagal memuat data Barang:", error);
    return [];
  }
};

export const getStokgudangOptions = async (idDepartemenSumber) => {
  if (!idDepartemenSumber) return [];
  try {
    const res = await api.get(
      `/Lookup/Stokgudang?idDepartemen=${idDepartemenSumber}`,
    );
    const data = Array.isArray(res.data) ? res.data : [];
    return data.map((item) => ({
      value: `${item.idBarang}-${item.modifiedDate}`, // tetap unik untuk UI
      idBarang: item.idBarang, // simpan idBarang asli sebagai INT
      kodeBarang: item.kodeBarang,
      label: item.namaBarang,
      jumlahStok: item.jumlahStok,
      idSatuan: item.idSatuan,
      namaSatuan: item.namaSatuan,
      hargaSatuan: item.hargaSatuan,
      idKodePersediaan: item.idKodePersediaan,
      idRekening: item.idRekening,
      modifiedDate: item.modifiedDate, // tambahkan ini
      noBatch: item.noBatch,
      expDate: item.expDate,
    }));
  } catch (error) {
    console.error("Gagal memuat data Stok Barang:", error);
    return [];
  }
};

export const getStokgudangUnikOptions = async (idDepartemenSumber) => {
  if (!idDepartemenSumber) return [];
  try {
    const res = await api.get(
      `/Lookup/Stokgudangunik?idDepartemen=${idDepartemenSumber}`,
    );
    const data = Array.isArray(res.data) ? res.data : [];
    return data.map((item) => ({
      value: item.idBarang, // simpan idBarang asli sebagai INT
      kodeBarang: item.kodeBarang,
      label: item.namaBarang,
    }));
  } catch (error) {
    console.error("Gagal memuat data Stok Barang:", error);
    return [];
  }
};

export const getKartuBarangOptions = async (idDepartemenSumber) => {
  try {
    const url = idDepartemenSumber
      ? `/Lookup/kartubarang?idDepartemen=${idDepartemenSumber}`
      : `/Lookup/kartubarang`;
    const res = await api.get(url);
    const data = Array.isArray(res.data) ? res.data : [];
    return data.map((item) => ({
      value: item.idBarang,
      kodeBarang: item.kodeBarang,
      label: item.namaBarang,
    }));
  } catch (error) {
    console.error("Gagal memuat data Stok Barang:", error);
    return [];
  }
};

export const getAllBarang = async () => {
  try {
    const res = await api.get(`/Lookup/Barang`);
    const data = Array.isArray(res.data) ? res.data : [];
    return groupByIdAndMap(data, "idKodePersediaan", (item) => ({
      value: item.idBarang,
      label: item.namaBarang,
      idSatuan: item.idSatuan,
    }));
  } catch (error) {
    console.error("Gagal memuat semua data Barang:", error);
    return {};
  }
};

export const getSatuanOptions = async () => {
  const res = await api.get("/Lookup/Satuan");
  return res.data;
};

export const getJabatanOptions = async () => {
  const res = await api.get("/Lookup/Jabatan");
  return res.data;
};

export const getDepartemenUserOptions = async () => {
  const res = await api.get("/Lookup/Departemen");
  return res.data;
};

export const getAllSatuan = getSatuanOptions;

/* sampai sini yg baru*/
// const res = await api.get("/Lookup/Departemen");
// const items = Array.isArray(res.data) ? res.data : []; // ✅ perbaikan
// return items.map((item) => ({
//   value: item.idDepartemen,
//   label: item.namaDepartemen,
// }));
export const getDepartemenOptions = async () => {
  const res = await api.get("/Lookup/Departemen");
  const items = Array.isArray(res.data) ? res.data : []; // ✅ perbaikan
  return items.map((item) => ({
    value: item.idDepartemen,
    label: item.namaDepartemen,
    idDepartemenSumber: item.idDepartemen, // alias untuk digunakan di tempat lain
    idDepartemen: item.idDepartemen, // tambahkan untuk kebutuhan auto select
  }));
};

export const getDepartemenListOptions = async () => {
  try {
    const res = await api.get("/Lookup/Departemen");
    // API sudah return array langsung
    return Array.isArray(res.data) ? res.data : [];
  } catch (err) {
    console.error("Gagal fetch departemen", err);
    return [];
  }
};

export const getDepartemenSumberOptions = async () => {
  const res = await api.get("/Lookup/Departemen");
  const items = Array.isArray(res.data) ? res.data : []; // ✅ perbaikan
  return items.map((item) => ({
    value: item.idDepartemen,
    label: item.namaDepartemen,
    idDepartemenSumber: item.idDepartemen, // alias untuk digunakan di tempat lain
    idDepartemen: item.idDepartemen, // tambahkan untuk kebutuhan auto select
  }));
};
export const getDepartemenTujuanOptions = async () => {
  const res = await api.get("/Lookup/Departemen");
  const items = Array.isArray(res.data) ? res.data : []; // ✅ perbaikan
  return items.map((item) => ({
    value: item.idDepartemen,
    label: item.namaDepartemen,
    idDepartemenTujuan: item.idDepartemen, // alias untuk digunakan di tempat lain
    idDepartemen: item.idDepartemen, // tambahkan untuk kebutuhan auto select
  }));
};

// export const getLokasiStokOptions = async () => {
//   const res = await api.get("/Lookup/Lokasistok");
//   const data = Array.isArray(res.data) ? res.data : [];
//   return data.map((item) => ({
//     value: item.idDepartemen,
//     label: item.namaDepartemen,
//   }));
// };

// export const getPersediaanOptions = async (idRekening) => {
//   try {
//     const res = await api.get(`/Lookup/Persediaan?IdRekening=${idRekening}`);
//     const data = Array.isArray(res.data) ? res.data : [];
//     return data.map((item) => ({
//       value: item.idKodePersediaan,
//      // label: `${item.kodePersediaan} ${item.namaPersediaan}`,
//       label: item.namaPersediaan,
//       kodePersediaan: item.kodePersediaan,
//     }));
//   } catch (error) {
//     if (error.response && error.response.status === 404) {
//       // Jika tidak ada data ditemukan, kembalikan array kosong
//       return [];
//     }
//     console.error("Gagal memuat data Persediaan:", error);
//     throw new Error("Gagal memuat data Persediaan");
//   }
// };

// export const getRekeningOptions = async () => {
//   try {
//     const res = await api.get("/Lookup/Rekening");
//     const data = Array.isArray(res.data) ? res.data : [];
//     return data.map((item) => ({
//       value: item.idRekening,
//       label: item.namaRekening,
//       kodeRekening:item.kodeRekening,
//     }));
//   } catch (error) {
//     console.error("Gagal memuat data Jenis Rekening:", error);
//     throw new Error("Gagal memuat data Jenis Rekening");
//   }
// };
// export const getBarangOptions = async (idKodePersediaan) => {
//   if (!idKodePersediaan) return []; // jangan lanjut kalau kosong

//   try {
//     const res = await api.get(`/Lookup/Barang?IdKodePersediaan=${idKodePersediaan}`);
//     const data = Array.isArray(res.data) ? res.data : [];
//     return data.map((item) => ({
//       value: item.idBarang,
//       label: item.namaBarang,
//       idSatuan: item.idSatuan, // tambahkan untuk kebutuhan auto select
//     }));
//   } catch (error) {
//     console.error("Gagal memuat data Barang:", error);
//     return [];
//   }
// };
// export const getSatuanOptions = async () => {
//   const res = await api.get("/Lookup/Satuan");
//   return res.data;
// };

export const getSatuanInputOptions = async () => {
  const res = await api.get("/Lookup/Satuan");
  const data = Array.isArray(res.data) ? res.data : [];
  return data.map((item) => ({
    value: item.idSatuan,
    label: item.namaSatuan,
  }));
};

export const getSupplierOptions = async () => {
  try {
    const res = await api.get("/Lookup/Supplier");
    const data = Array.isArray(res.data) ? res.data : [];
    return data.map((item) => ({
      value: item.idSupplier,
      label: item.namaSupplier,
    }));
  } catch (error) {
    console.error("Gagal memuat data Jenis Supplier:", error);
    throw new Error("Gagal memuat data Jenis Supplier");
  }
};
export const getBapOptions = async () => {
  try {
    const res = await api.get("/Lookup/Bap");
    const data = Array.isArray(res.data) ? res.data : [];
    return data.map((item) => ({
      value: item.idPengadaan,
      label: item.nomorBap,
    }));
  } catch (error) {
    console.error("Gagal memuat data Jenis Supplier:", error);
    throw new Error("Gagal memuat data Jenis Supplier");
  }
};

// export const getUserpjOptions = async () => {
//   const res = await api.get("/Lookup/Userpj");
//   const items = Array.isArray(res.data) ? res.data : []; // ✅ perbaikan
//   return items.map((item) => ({
//     value: item.idUser,
//     label: item.namaLengkap,
//     idKetuaBap: item.idUser,
//     idAnggotaABap: item.idUser,
//   }));
// };

export const getUserpjOptions = async () => {
  const res = await api.get("/Lookup/Userpj");
  const items = Array.isArray(res.data) ? res.data : [];

  return items.map((item) => ({
    value: item.idUser,
    label: item.namaLengkap,
    nip: item.nip,
  }));
};

// Ambil semua role untuk dropdown
// export const getRoleOptions = async () => {
//   try {
//     const res = await api.get("/Lookup/Role"); // sesuaikan endpoint backend
//     const items = Array.isArray(res.data) ? res.data : [];
//     return items.map((item) => ({
//       value: item.idRole,
//       label: item.namaRole,
//     }));
//   } catch (error) {
//     console.error("Gagal memuat data Role:", error);
//     return [];
//   }
// };
export const getRoleOptions = async () => {
  const res = await api.get("/Lookup/Role");
  return res.data;
};

export const getJenisTransaksiOptions = async () => {
  try {
    const res = await api.get("/Lookup/Jtran");
    const data = Array.isArray(res.data) ? res.data : [];

    return data
      .filter((item) => [7, 8].includes(item.idJenisTransaksi))
      .map((item) => ({
        value: item.idJenisTransaksi,
        label: item.namaJenisTransaksi,
      }));
  } catch (error) {
    console.error("Gagal memuat data Jenis Transaksi:", error);
    throw new Error("Gagal memuat data Jenis Transaksi");
  }
};

export const getProkegOptions = async () => {
  const res = await api.get("/Lookup/Prokeg");
  return res.data;
};

// Get all Barang (digunakan untuk lookup label atau data tambahan)
// export const getAllBarang = async () => {
//   try {
//     const res = await api.get("/api/barang");
//     return Array.isArray(res.data?.items) ? res.data.items : [];
//   } catch (error) {
//     console.error("Gagal mengambil data Barang:", error);
//     return [];
//   }
// };

// Get all Rekening
// export const getAllRekening = async () => {
//   try {
//     const res = await api.get("/api/rekening");
//     return Array.isArray(res.data?.items) ? res.data.items : [];
//   } catch (error) {
//     console.error("Gagal mengambil data Rekening:", error);
//     return [];
//   }
// };

// // Get all Satuan
// export const getAllSatuan = async () => {
//   try {
//     const res = await api.get("/api/satuan");
//     return Array.isArray(res.data?.items) ? res.data.items : [];
//   } catch (error) {
//     console.error("Gagal mengambil data Satuan:", error);
//     return [];
//   }
// };

// Get all Supplier
export const getAllSupplier = async () => {
  try {
    const res = await api.get("/api/supplier");
    return Array.isArray(res.data?.items) ? res.data.items : [];
  } catch (error) {
    console.error("Gagal mengambil data Supplier:", error);
    return [];
  }
};

// Get all User Penanggung Jawab
export const getAllUserpj = async () => {
  try {
    const res = await api.get("/Lookup/Userpj");
    return Array.isArray(res.data) ? res.data : []; // sesuai struktur user
  } catch (error) {
    console.error("Gagal mengambil data User Penanggung Jawab:", error);
    return [];
  }
};

// Get all Departemen
export const getAllDepartemen = async () => {
  try {
    const res = await api.get("/lookup/Departemen");
    return Array.isArray(res.data) ? res.data : []; // sesuai struktur departemen
  } catch (error) {
    console.error("Gagal mengambil data Departemen:", error);
    return [];
  }
};
